var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C1.72208e-07 13.0302 0.387987 11.0796 1.14181 9.25974C1.89563 7.43986 3.00052 5.78627 4.3934 4.3934C5.78628 3.00052 7.43987 1.89563 9.25975 1.1418C11.0796 0.387985 13.0302 -2.43722e-06 15 -2.26502e-06C16.9698 -2.09281e-06 18.9204 0.387985 20.7403 1.14181C22.5601 1.89563 24.2137 3.00052 25.6066 4.3934C26.9995 5.78628 28.1044 7.43987 28.8582 9.25975C29.612 11.0796 30 13.0302 30 15L15 15L0 15Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.50003C15.8284 8.50003 16.5 9.1716 16.5 10V20C16.5 20.8285 15.8284 21.5 15 21.5C14.1716 21.5 13.5 20.8285 13.5 20V10C13.5 9.1716 14.1716 8.50003 15 8.50003Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4999 15C21.4999 15.8284 20.8284 16.5 19.9999 16.5L9.99994 16.5C9.17151 16.5 8.49994 15.8284 8.49994 15C8.49994 14.1716 9.17151 13.5 9.99994 13.5L19.9999 13.5C20.8284 13.5 21.4999 14.1716 21.4999 15Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 27C21.6274 27 27 21.6274 27 15C27 8.37258 21.6274 3 15 3C8.37258 3 3 8.37258 3 15C3 21.6274 8.37258 27 15 27ZM15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd);
export default __webpack_public_path__ + "static/media/ic_add.6bf443c4fc5f4a7940ba5acfd537c186.svg";
export { ForwardRef as ReactComponent };